import '../io/lch/index.js';
import Color from '../Color.js';
import LAB_CONSTANTS from '../io/lab/lab-constants.js';
Color.prototype.saturate = function () {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var me = this;
  var lch = me.lch();
  lch[1] += LAB_CONSTANTS.Kn * amount;
  if (lch[1] < 0) lch[1] = 0;
  return new Color(lch, 'lch').alpha(me.alpha(), true);
};
Color.prototype.desaturate = function () {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.saturate(-amount);
};